
import React, { Component } from 'react'
import MenuItem from 'material-ui/MenuItem'
import MasterDetailLayout from 'components/MasterDetailLayout'
import Header from 'components/Header'
import AddButton from 'components/AddButton'
import Hamburger from 'components/Hamburger'
import TenantTable from './Table'
import TenantForm from '../tenantForm'
import FiltersPicker from 'components/FiltersPicker'
import Notifications from 'components/ListLayoutParts/Notifications'
import Search from 'components/Search'

export default class TenantPage extends Component {
	render() {
		let { props } = this
		let detailID = props.routeParams.id
		let header = (style) => (
			<Header {...{style}}>
				<Hamburger />
				<div>
					<FiltersPicker entity={'tenant'} />
					<Notifications />
					{<div style={{
							float: "right"
						  , position: "relative"
						  , top: "-24px"
						  , left: "240px"}}
					>
						<Search  entity={'tenant'} id="search-tenants" style={{marginTop: "-8px"}}/><
					/div>}
				</div>
				<AddButton object={{type:'tenant'}} color="#FFF" detailID={detailID}/>
			</Header>
		)
		return(
			<MasterDetailLayout
				header={header}
				master={props => <TenantTable {...props} detailID={detailID} />}
				detail={props => <TenantForm {...props} id={detailID} /> }
				detailColumns={1}
				detailOpen={!!detailID}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/tenants/index.js